import React from "react";
import ClientPicture from "./ClientPicture";
import { dateToStringShort } from "../utils/DateHelper";

class HeaderPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { client, account } = this.props;

    if (!client.created) return null;

    const name = client.name;
    const createdString = dateToStringShort(client.created.toDate());

    return (
      <div className="HeaderPanel">
        <table>
          <tbody>
            <tr>
              <th id="NoDivider" rowSpan={2}>
                <ClientPicture big clientId={client.id} account={account} />
              </th>
              <th id="Title">{name}</th>
              <th id="Title">Projekte</th>
              <th id="Title">Freigaben</th>
              <th id="Title">Wartend</th>
              <th id="Title">Abgelehnt</th>
            </tr>
            <tr>
              <th>{createdString}</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default HeaderPanel;



// WEBPACK FOOTER //
// ./src/components/HeaderPanel.js